/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { setSelectedContentProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import QuestionFormat from 'pages/dashboard/embeds/management/customize/pageproperties/questionproperties/questionformat/questionformat';


/* ========== ~~~~~~~~~~ QUESTION FORMAT : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState }, { type }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    return {
        selectedType: !contentStatus.noLiveContents ? contentStatus.contents[contentStatus.selectedContent].questionBased.type: null,
        type
    }
};

const mapDispatchToProps = dispatch => ({
    setSelectedContentProperty: (isSharedProperty, property, value) => dispatch(setSelectedContentProperty(isSharedProperty, property, value))
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionFormat);
